// extracted by mini-css-extract-plugin
module.exports = {"winArrowContainer":"winArrowContainer__wZscVBYo2malQ","winArrow":"winArrow__DiEnEhq6JlCfq"};